import Vue from "vue";

/**
 * Tracks the user login
 */
export const trackLogin = ({ user = "user" }) => {
  Vue.gtag
    ? Vue.gtag.event("Login", {
        event_category: "auth",
        event_label: "success",
        value: user,
      })
    : null;
};

/**
 * Tracks failed login attempts
 */
export const trackFailedLogin = () => {
  Vue.gtag
    ? Vue.gtag.event("Failed Login", {
        event_category: "auth",
        event_label: "failed",
      })
    : null;
};

/**
 * Tracks forgot password clicks
 */
export const trackForgotPassword = () => {
  Vue.gtag
    ? Vue.gtag.event("Click Forgot Password", {
        event_category: "auth",
        event_label: "click",
      })
    : null;
};

/**
 * Tracks user sign ups
 */
export const trackSignUp = ({ user = "user" }) => {
  Vue.gtag
    ? Vue.gtag.event("Sign Up", {
        event_category: "auth",
        event_label: "success",
        value: user,
      })
    : null;
};

/**
 * tracks console open clicks
 */
export const trackConsoleClicks = ({ dashboard_id = "dash_id" }) => {
  Vue.gtag
    ? Vue.gtag.event("Open Console", {
        event_category: "console",
        event_label: "click",
        value: dashboard_id,
      })
    : null;
};

/**
 * Tracks create console button clicks
 */
export const trackCreateConsoleClicks = () => {
  Vue.gtag
    ? Vue.gtag.event("Create Console", {
        event_category: "console",
        event_label: "click",
      })
    : null;
};

/**
 * Tracks console saves
 */
export const trackConsoleSave = () => {
  Vue.gtag
    ? Vue.gtag.event("Save Console", {
        event_category: "console",
        event_label: "click",
      })
    : null;
};
